import authService from "../../services/AuthService";
export default {
  isAuthenticated: authService.isAuthenticated
};